import { CreateElement } from "./element";
import { Relationship } from "./relationship";

interface OptionsAltchunk {
    /** File content */
    file: ArrayBuffer;
    /** File type */
    type: "docx" | "html" | "mht" | "rtf";
}

/**
 * Create bookmark
 */
class CreateAltchunk extends CreateElement {
    /**
     * Id
     */
    protected id: string;

    /**
     * Element options
     */
    protected options: OptionsAltchunk;

    /**
     * Constructor
     *
     * @param options - Options altchunk
     * @param id - Id
     */
    constructor(options: OptionsAltchunk, id: string) {
        super();

        this.options = options;
        this.id = id;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        let contents =
            '<w:altChunk r:id="rId' +
            this.id +
            '" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main">';

        if (this.options.type == "docx") {
            contents += "<w:altChunkPr><w:matchSrc/></w:altChunkPr>";
        }

        contents += "</w:altChunk>";

        // keep altChunk external relationships
        const newExternalRelationship: Relationship = {
            id: "rId" + this.id,
            target: this.id + "." + this.getRelationshipFileExtension(),
            targetMode: "Internal",
            type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/aFChunk",
        };
        this.externalRelationships.push(newExternalRelationship);

        // keep default from the element
        this.externalDefaults.set(
            this.getRelationshipFileExtension(),
            this.getMime()
        );

        // keep file from the element
        this.fileContents.set(
            "word/" + this.id + "." + this.getRelationshipFileExtension(),
            this.options.file
        );

        return contents;
    }

    /**
     * Gets mime to be added
     *
     * @returns Mime type
     */
    public getMime(): string {
        let mimeType = "";
        switch (this.options.type) {
            case "docx":
                mimeType =
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml";
                break;
            case "html":
                mimeType = "application/xhtml+xml";
                break;
            case "mht":
                mimeType = "message/rfc822";
                break;
            case "rtf":
                mimeType = "application/rtf";
                break;
        }

        return mimeType;
    }

    /**
     * Gets file extension to be added as relationship
     *
     * @returns File extension
     */
    public getRelationshipFileExtension(): string {
        let fileExtension = "";
        switch (this.options.type) {
            case "docx":
                fileExtension = "zip";
                break;
            case "html":
                fileExtension = "htm";
                break;
            case "mht":
                fileExtension = "mht";
                break;
            case "rtf":
                fileExtension = "rtf";
                break;
        }

        return fileExtension;
    }
}

export { CreateAltchunk, OptionsAltchunk };
